import { Loader } from '@oriola-corporation/kronan-icons';
import React, { useMemo } from 'react';
import { useAsync } from 'react-use';
import { getClickCollectData } from '../../api/api';
import { usePharmacy } from '../../contexts/Pharmacy';
import { convertSecondsToHoursAndMinutes } from '../../util/util';
import { Card } from '../Card';
import { Header } from '../Header/Header';
import { Text } from '../TypographyComponents';
import { ReviewMessage } from './ReviewMessage';

export const Time = (props: { time: string; style?: unknown }) => {
  const { time } = props;

  const theTime = useMemo(() => convertSecondsToHoursAndMinutes(time), [time]);

  return (
    <span>
      {theTime.hours > 0 && `${theTime.hours} tim`}{' '}
      {theTime.minutes > 0 && `${theTime.minutes} min`}{' '}
    </span>
  );
};

const ToolTipContent = () => {
  return (
    <div>
      <p>
        Här syns statistik för hur snabbt just ert apotek färdigställer en Click & Collect
        Express-beställning.
      </p>
      <p>Vårt löfte och kundens förväntning är att beställningarna ska vara klara inom 2 timmar.</p>
      <p>
        Plocktid är medianvärdet av era senaste 10 ordrar. Senaste ordern är plocktiden för den
        senaste ordern ni har gjort klart. Klar inom 2h visar procentandelen ordrar som är klara
        inom kundlöftet 2 timmar. <br />
      </p>
      <p>
        Detta beräknas på de senaste 20 ordrarna, för att ge ett så rättvisande resultat som
        möjligt.
      </p>
    </div>
  );
};

export const ClickCollectStats = () => {
  const pharmacy = usePharmacy();

  const clickCollectState = useAsync(async () => {
    return getClickCollectData(pharmacy.id);
  });

  if (clickCollectState.error) {
    return (
      <Card>
        <h3>Misslyckades med att ladda click collect</h3>
      </Card>
    );
  }

  return (
    <>
      <Header tooltip={<ToolTipContent />}>Click & Collect Express</Header>
      <Card>
        {clickCollectState.loading ? (
          <Loader isRotating />
        ) : clickCollectState.value?.pharmacyId ? (
          <div>
            <div style={{ borderBottom: '1px solid #ccc', paddingBottom: 16 }}>
              <Text secondary>
                Er plocktid (senaste {clickCollectState.value.numberOfOrders} ordrar)
              </Text>
              <Time
                style={{ fontSize: '48px', fontWeight: '500' }}
                time={clickCollectState.value.avgCollectingTime}
              />
            </div>

            <Text includeDivider secondary>
              Senaste order:{' '}
              <span>
                <Time time={clickCollectState.value.latestOrder} />
              </span>
            </Text>
            <Text includeDivider secondary>
              Leveranser inom 2h: <span>{clickCollectState.value.promisedDeliveryPercentage}%</span>
            </Text>
            <Text large>
              <ReviewMessage percentage={clickCollectState.value.promisedDeliveryPercentage} />
            </Text>
          </div>
        ) : (
          <p>Det finns ingen data för nuvarande apotek.</p>
        )}
      </Card>
    </>
  );
};
